/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_DescInputs */

const en_st_wl_desc = /** @type {(inputs: St_Wl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us how you write proposals today. We open Studio to the list first.`)
};

const id_st_wl_desc = /** @type {(inputs: St_Wl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan cara kamu membuat proposal sekarang. Studio dibuka lebih dulu untuk daftar ini.`)
};

/**
* | output |
* | --- |
* | "Tell us how you write proposals today. We open Studio to the list first." |
*
* @param {St_Wl_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_desc = /** @type {((inputs?: St_Wl_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_desc(inputs)
	return en_st_wl_desc(inputs)
});